import React from 'react';

import CampaignIcon from '@mui/icons-material/Campaign';
import { Alert, AlertTitle, Box } from '@mui/material';

import ClaimsWizard from './Claims/ClaimsWizard';

export default function LoyaltyUserClaimsPage() {
  return (
    <Box>
      <Alert icon={<CampaignIcon />} severity="info" sx={{ mb: 3 }}>
        <AlertTitle>Process Campaign Redemptions</AlertTitle>
        Process campaign redemptions for customers in bulk or via manual entry, granting tier upgrades, points, status
        credits, or combinations of these benefits.
      </Alert>
      <ClaimsWizard />
    </Box>
  );
}
